function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
import { defineComponent, ref, reactive, computed, watch } from "vue";
import MultiRatioCover from "@com/components/multi-ratio-cover/index.vue";
import { coverOptions } from "@com/components/multi-ratio-cover/index";
import { definePropType } from "@types-vue/props";
import { updateTemplate, updateFragment } from "@/api/veditor/index";
import { VideoTemplateType } from "@pt/api/template/index.type";
import { onlyInnerOptions } from "../index";
import TableFromModel from "../from";
import { Message } from "element-ui";
export default defineComponent({
    components: {
        MultiRatioCover: MultiRatioCover
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        row: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        },
        // 入口
        inlet: {
            type: definePropType(String),
            default: "template"
        },
        // 片段数据
        fragmentTags: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleClose = function handleClose() {
            var _$ref, _$ref1;
            (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.clearValidate();
            (_$ref1 = formRef.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.resetFields();
            emit("update:visible", false);
        };
        var handleSaveAsset = function handleSaveAsset() {
            var _$ref;
            formRef && ((_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function(valid) {
                if (valid) {
                    loading.value = true;
                    var params = _objectSpreadProps(_objectSpread({}, formData), {
                        ids: [
                            props.row.id
                        ]
                    });
                    if (formData.cover_previews) {
                        params.cover_previews = JSON.stringify(formData.cover_previews);
                    } else {
                        delete params.cover_previews;
                    }
                    if (formData.tag_ids && formData.tag_ids.length) {
                        params.tag_ids = props.inlet === "template" ? formData.tag_ids.map(Number) : formData.tag_ids;
                    } else {
                        delete params.tag_ids;
                    }
                    if (formData.industry_ids && formData.industry_ids.length) {
                        params.industry_ids = formData.industry_ids.map(Number);
                    } else {
                        delete params.industry_ids;
                    }
                    var api = props.inlet === "template" ? updateTemplate : updateFragment;
                    api(params).then(function() {
                        Message.success("\u64CD\u4F5C\u6210\u529F");
                        loading.value = false;
                        emit("refresh");
                        handleClose();
                    }).finally(function() {
                        loading.value = false;
                    });
                }
            }));
        };
        var _$ref2 = TableFromModel(), template_tags = _$ref2.template_tags, industry_categories = _$ref2.industry_categories;
        var loading = ref(false);
        var formRef = ref();
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var defaultProps = computed(function() {
            return {
                children: props.inlet === "template" ? "child" : "sub_tag",
                emitPath: false,
                label: "name",
                value: "id",
                multiple: true
            };
        });
        var formData = reactive({
            name: "",
            name_en: "",
            industry_ids: [],
            tag_ids: [],
            only_inner: 1,
            cover_previews: ""
        });
        var tagOptions = computed(function() {
            if (props.inlet === "template") {
                return template_tags.value;
            }
            return props.fragmentTags;
        });
        var getTemplateCover = function(val) {
            formData.cover_previews = val;
        };
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                var _$ref;
                (_$ref = formRef.value) === null || _$ref === void 0 ? void 0 : _$ref.clearValidate();
                formData.name = props.row.name;
                formData.name_en = props.row.name_en;
                formData.industry_ids = props.row.industry_ids ? String(props.row.industry_ids).split(",").map(Number) : [];
                formData.tag_ids = props.row.tag_ids ? props.row.tag_ids.split(",") : [];
                formData.only_inner = props.row.only_inner;
                if (props.row.cover_previews) {
                    var _loop = function(s) {
                        if (props.row.cover_previews[s] === null) {
                            return {
                                v: void void 0
                            };
                        }
                        coverOptions.forEach(function(t) {
                            if (t.value === s) {
                                t.url = props.row.cover_previews[s];
                            }
                        });
                    };
                    for(var s in props.row.cover_previews){
                        var _ret = _loop(s);
                        if (_typeof(_ret) === "object") return _ret.v;
                    }
                }
            } else {
                // 初始化封面的集合
                // eslint-disable-next-line no-sequences
                coverOptions.map(function(t) {
                    return t.cover_previews = {}, t.url = {};
                });
                handleClose();
            }
        });
        return {
            loading: loading,
            formRef: formRef,
            formData: formData,
            tagOptions: tagOptions,
            coverOptions: coverOptions,
            dialogVisible: dialogVisible,
            defaultProps: defaultProps,
            VideoTemplateType: VideoTemplateType,
            onlyInnerOptions: onlyInnerOptions,
            industry_categories: industry_categories,
            handleClose: handleClose,
            handleSaveAsset: handleSaveAsset,
            getTemplateCover: getTemplateCover
        };
    }
});
